import React from 'react'
import { Ordering } from 'storfox-filter'

import { CONTRACT_COLUMNS as tableColumns } from './ContractTable'

import { FILTER_NAME as name } from '../../../constants/Contract'

export const contractOrderingOptions = {
  name,
  tableColumns
}

function ContractOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default ContractOrderingForm
